import PropTypes from 'prop-types'
import React from 'react'
import Icon from 'components/Icon'
import UserRow from 'components/UserRow'
import { getFullNameUserUtil } from 'models/daos/user/utils'
import { BubbleIcon } from 'components/Icon/icons/bubble'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'
import { View } from 'components/View'
import getValueReduxUtil from 'modules/redux/utils/get-value'

class CommentUser extends React.Component {
  static defaultProps = {
    value: null,
    currentUser: null,
    comment: null,
    isNew: null
  }

  static propTypes = {

    value: PropTypes.object,
    currentUser: PropTypes.object,
    comment: PropTypes.string,
    isNew: PropTypes.bool
  }

  renderBubble () {
    return (
      <Icon
        icon={BubbleIcon}
        size={Icon.SIZE.MEDIUM}
      />
    )
  }

  renderBubbleOrUser () {
    if (
      !!this.props.value ||
      (
        this.props.isNew && this.props.currentUser
      )
    ) {
      return this.renderUser()
    }
    return this.renderBubble()
  }

  renderUser () {
    const user = this.props.value || this.props.currentUser
    const { comment } = this.props
    const paddingRight = (
      !comment && comment !== '' ? null : STYLES_PADDING.MEDIUM
    )
    return (
      <View
        style={{
          flexDirection: View.DIRECTION.ROW,
          alignItems: View.ALIGN.START,
          justifyContent: View.JUSTIFY.START,
          height: '100%'
        }}
      >
        <div
          style={{
            paddingRight
          }}
        >
          <UserRow.Avatar
            size={UserRow.Avatar.SIZE.MEDIUM}
            value={
              getValueReduxUtil(user, 'avatarThumbnail') ||
              getValueReduxUtil(user, 'avatar')
            }
          />
        </div>
        {this.renderUserFullName()}
      </View>
    )
  }

  renderUserFullName () {
    const { comment } = this.props
    if (!comment && comment !== '') {
      return
    }
    return (
      <UserRow.FullName
        value={getFullNameUserUtil(this.props.value)}
      />
    )
  }

  render () {
    let hasComment
    if (this.props.comment || this.props.comment === '') {
      hasComment = true
    } else {
      hasComment = false
    }
    return (
      <div
        style={{
          paddingBottom: hasComment ? STYLES_PADDING.SMALL : null,
          paddingRight: STYLES_PADDING.MEDIUM,
          width: hasComment ? '100%' : null
        }}
      >
        {this.renderBubbleOrUser()}
      </div>
    )
  }
}

export default CommentUser
